/**
 *
 * This handles callbacks from the Amazon cognito authentication system
 *
 */

import React from //	useEffect, //	useState,
'react';
//import {
//useSelector,
//useDispatch,
//} from 'react-redux';
//import cookie from 'react-cookies'
import { Redirect } from 'react-router-dom';
import {
	//actionLoginUser,
	actionLogoutUser,
	//actionCognitoSignout,
	//clearUserCookies,
	//loadAuthFromCookies,
	actionFetchTokens,
	//actionRefreshTokens,
	//actionFetchAuthorisation,
} from './actions.js';

//import jwt from 'jwt-decode'
//import { useHistory } from 'react-router-dom'

/**
 * Callback is called by the initial caspio login request.
 * It returns a code
 *
 * Keep this sync to avoid the "page flash" keeping the divert last.
 *
 * @param {*} props
 */
export const Callback = (props) => {
	//const [username, setUsername] = useState( '' );
	//const dispatch = useDispatch()
	//const history = useHistory();
	const parseSearch = () => {
		//var params = {}
		let code = '';
		const searchStr = props.location.search.replace(/^#/g, ''); //strip # from start of string
		searchStr.split('?').map((hk) => {
			const temp = hk.split('=');
			if (temp[0] === 'code') {
				code = temp[1];
			}
			//params[temp[0]] = temp[1]
			return null;
		});
		return code;
	};

	// const parseHash = () => {
	// 	var params = {}
	// 	const hash = props.location.hash.replace(/^#/g, '');//strip # from start of string
	// 	hash.split('&').map(hk => {
	// 		let temp = hk.split('=');
	// 		params[temp[0]] = temp[1]
	// 		return (null)
	// 	});
	// 	return params
	// }

	const handleLogin = async () => {
		//const response = parseHash()
		const code = parseSearch(); //	extract code from returned string
		try {
			await actionFetchTokens(code); //get the tokens from ow auth api using the cognito code
			return <Redirect to="/" />;
		} catch (error) {
			console.log('error in login', error);
			actionLogoutUser();
		}
	};
	handleLogin();
	// handleLogin().then(()=>{
	// 	//return (<Redirect  to="/" />);
	// 	history.push('/');
	// });
	//setInterval( actionRefreshTokens ,3000);//debug
	//return (<h2>Logging in to server</h2>)
	//return (null)
	//return <LoginLogoutFlashScreen action = {'login'} />
	return <Redirect to="/" />; // when all tasks are done sequentially the load the home page
};
